import type { AxiosRequestInterceptors, AxiosRequest, AxiosResponse } from '@fanghub/tool-request'
import { getToken } from '@/utils/token'

export const permissionHandler: AxiosRequestInterceptors<AxiosRequest, AxiosResponse> = {
    // 请求拦截：添加 Token 到请求头
    requestInterceptor: (config: AxiosRequest) => {
        const { needPremission } = config
        if (!needPremission) {
            return config
        } else {
            const token = getToken()
            if (token && config.headers) {
                config.headers.Authorization = `Bearer ${token}`
                return config
            }
        }
    }
}
